export const acceptText = 'By checking this box, I acknowledge that I have read and agree to the'
export const termsAndConditions =
  'Rooms To Go Terms and Conditions of Sale, Limited Product Warranty, and Dispute Resolution/Arbitration Agreement'
export const termsOfUse = 'Terms of Use'
export const SEVEN_YEAR_WARRANTY_NAMES = ['B9-FURADJ7Y', 'RTGLOSADJBEDI7YD', 'R7ABA']

/**
 * The following Legal Requirement Names match those initially assigned
 * to order.reviewInfo via src/redux/modules/checkout.js:
 *  acceptTerms, acceptPickupTerms, acceptServiceContractTerms, acceptSevenYearTerms
 */
export const LEGAL_REQUIREMENT_NAMES = {
  TOC: 'acceptTerms',
  PICKUP: 'acceptPickupTerms',
  ESC3YR: 'acceptServiceContractTerms',
  ESC7YR: 'acceptSevenYearTerms',
}
